import React from 'react'
import { itemQuantity } from '../../../../shared/item-count.js'
import { lineTotals, formatLinePounds } from './lineTotals.js'

// A quote line's Qty and prices, in the `.parsed-item-prices` row.
// Prices are per unit. Qty 1 reads Qty, SP, BP. Above 1 it reads Qty, L-SP,
// L-BP (one unit), then T-SP and T-BP (the whole line, worked out, never
// edited). The labels carry the meaning, so colour is not the only cue.
// Quote Assessment passes its click-to-edit cells in as qtyCell, spCell and
// bpCell. Read-only screens leave them out.

const MISSING = '—'

export default function LinePrices({ qty, sp, bp, qtyCell, spCell, bpCell }) {
  const units = itemQuantity({ quantity: qty })
  const isMulti = units > 1
  const { totalSp, totalBp } = lineTotals(qty, sp, bp)
  return (
    <>
      <Field label="Qty">{qtyCell ?? <span className="price-value">{qty}</span>}</Field>
      <Field label={isMulti ? 'L-SP' : 'SP'} title={isMulti ? 'L-SP: sell price for one unit' : undefined}>
        {spCell ?? <UnitPrice price={sp} className="price-sp" />}
      </Field>
      <Field label={isMulti ? 'L-BP' : 'BP'} title={isMulti ? 'L-BP: buy price for one unit' : undefined}>
        {bpCell ?? <UnitPrice price={bp} className="price-bp" />}
      </Field>
      {isMulti && (
        <>
          <span className="line-prices-divider" aria-hidden="true" />
          <Field label="T-SP" title={`T-SP: total sell price, L-SP × ${units}`}>
            <TotalPrice pounds={totalSp} className="price-sp" />
          </Field>
          <Field label="T-BP" title={`T-BP: total buy price, L-BP × ${units}`}>
            <TotalPrice pounds={totalBp} className="price-bp" />
          </Field>
        </>
      )}
    </>
  )
}

function Field({ label, title, children }) {
  return (
    <div className="price-field">
      <span className="price-label" title={title}>{label}</span>
      {children}
    </div>
  )
}

function UnitPrice({ price, className }) {
  const missing = price == null || price === ''
  return <span className={`price-value ${className}`}>{missing ? MISSING : `£${price}`}</span>
}

function TotalPrice({ pounds, className }) {
  const text = pounds == null ? MISSING : formatLinePounds(pounds)
  return <span className={`price-value ${className}`}>{text}</span>
}
